import { initRecaptcha } from 'recaptcha';

document.addEventListener('DOMContentLoaded', () => {
  initRecaptcha();
});
